import { applyAutogrow } from '~/utils/autogrow'

export default defineNuxtPlugin((nuxtApp) => {
  const resize = (el: HTMLTextAreaElement) => applyAutogrow(el)

  nuxtApp.vueApp.directive('autogrow', {
    mounted(el: HTMLTextAreaElement) {
      const fn = () => resize(el)
      fn()
      el.addEventListener('input', fn)
      ;(el as any)._agFn = fn
    },
    updated(el: HTMLTextAreaElement) {
      ;(el as any)._agFn?.()
    },
    unmounted(el: HTMLTextAreaElement) {
      el.removeEventListener('input', (el as any)._agFn)
    },
  })
})
